import { Component, OnInit } from '@angular/core';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
import { UserService } from '../../shared/user.service';
import { Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  register: any = {};
  formSubmitted: boolean;
  data: any;
  districtlist: any;
  taluklist:any;
  statelist: any;
  title = "User Registration";
  user: any = {};
  date: any;
  Show: any = "N";
  numericpattern = "^[0-9]*$";
  emailpattern = "^[a-zA-Z0-9._%-+]+@[a-z0-9.-]+\.[a-z]{2,3}$";

  // dt = new Date();
  constructor(private userService: UserService, private errorHandler: ErrorHandler, private router: Router) {
    this.formSubmitted = false;
    //this.register = new Register();
  }

  ngOnInit() {
    debugger
    this.GetAllState();
    //this.date = this.add_months(this.dt, 3)

  }

  // add_months(dt, n) {

  //   return new Date(dt.setMonth(dt.getMonth() + n));
  // }

  GetAllState() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllStates();
    this.data.subscribe(
      (response: any) => {
        this.statelist = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllDistrictById(ID: any) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllDistrictById(ID);
    this.data.subscribe(
      (response: any) => {
        this.districtlist = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });

  }

  GetTalukbyId(ID: any) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetTalukbyId(ID);
    this.data.subscribe(
      (response: any) => {
        this.taluklist = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });

  }

  onSubmit(form: NgForm, register: any) {
    debugger
    if(register.REG_Org_Name==undefined||null || register.REG_Address1==undefined||null || register.REG_Address2==undefined||null
      || register.REG_State==undefined||null || register.REG_District==undefined|| null || register.REG_Taluk==undefined||null
      || register.REG_Contact_No==undefined||null || register.REG_EmailId==undefined||null || register.REG_Contact_Person==undefined||null
      || register.REG_Mob_No==undefined||null || register.REG_Contact_EmailId==undefined||null || register.REG_Password==undefined|| null ||
      register.REG_Confirm_Password==undefined||null)
      {
        swal('Empty Fields','Please fill all the mandatory fields','warning');
      }
    // if (!form.invalid) {
    else  if(register.REG_OTP!="" || register.REG_OTP!=undefined || register.REG_OTP!=null){
      form.value.RoleId = "e70aa274-04ba-485f-b54f-f0f3e6068c72"
      form.value.OfficeId = "1"
      form.value.UserName = form.value.REG_EmailId;
      form.value.OTP = form.value.REG_OTP;
      form.value.Password = form.value.REG_Password;
      form.value.ConfirmPassword = form.value.REG_Confirm_Password;
      form.value.Registration = register;
      document.getElementById('loader-spinner').style.display = "block";
      console.log(form.value);
      this.data = this.userService.registerCustomers(form.value);
      this.data.subscribe(
        (response) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('', 'Registered Successfully!', 'success');
          this.router.navigate(['/login']);
        }, (error) => {
          
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
    // } else
    //   this.formSubmitted = true;
     } else
     swal('', 'Please enter OTP!', 'warning');
  }

  Verify(Mob_No: any) {
    debugger
    if(this.register.REG_Org_Name==undefined||null || this.register.REG_Address1==undefined||null || this.register.REG_Address2==undefined||null
      || this.register.REG_State==undefined||null || this.register.REG_District==undefined|| null || this.register.REG_Taluk==undefined||null
      || this.register.REG_Contact_No==undefined||null || this.register.REG_EmailId==undefined||null || this.register.REG_Contact_Person==undefined||null
      || this.register.REG_Mob_No==undefined||null || this.register.REG_Contact_EmailId==undefined||null || this.register.REG_Password==undefined|| null ||
      this.register.REG_Confirm_Password==undefined||null)
      {
        swal('Empty Fields','Please fill all the mandatory fields','warning');
      }
    else if(Mob_No!="" || Mob_No!=undefined || Mob_No!=null)
    {
    debugger
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.VerifyMobileNo(Mob_No);
    this.data.subscribe(
      (response: any) => {
        this.Show = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        swal('', error.error.Message, 'warning');
        document.getElementById('loader-spinner').style.display = "none";
      });
    }
    else{
      swal('', 'Please enter mobile number!', 'warning');
    }
  }
  ResendOtp(Mob_No: any) {
    debugger
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.ResendOtp(Mob_No);
    this.data.subscribe(
      (response: any) => {
        swal('', 'OTP Sent!', 'success');
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        swal('', error.error.Message, 'warning');
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/registration/signup/signup.component.ts